export default __webpack_public_path__ + "static/media/models.8121b72c.jfif";